import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useWatch } from "react-hook-form";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { TextField } from "@mui/material";
import { Search, CloudDownload, Delete } from "@mui/icons-material";
import { TfiEmail } from "react-icons/tfi";
import Select from "react-select";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";

import swal from "sweetalert";
import moment from "moment";

import {
  fetchAreasOrganizacionales,
  selectAllAreasOrganizacionales
} from "../../redux/AreaOrganizacional/AreaOrganizacionalSlice";

import {
  fetchAllEmpleados,
  selectAllEmpleadosList
} from "./../../redux/Empleados/EmpleadosSlice";

import { fetchEnvioCorreoSupervisores } from "../../redux/Reportes/ReporteAsistenciasSlice";
  
export const FiltroReporteAsistenciaCard = ({
  searchReporteAsistencia,
  setArea,
  ReporteAsistenciaExcel,
  reset,
  form
}) => {

  // ? HOOK-DISPATCH
  const dispatch = useDispatch();

  // ? HOOK-SELECTOR
  const listAreaOrganizacionales = useSelector(selectAllAreasOrganizacionales);
  const listEmpleados = useSelector(selectAllEmpleadosList);

  // ? HOOK-STATE
  const [listaAreasState, setListaAreasState] = useState([]);
  const [listaEmpleadosState, setListaEmpleadosState] = useState([]);

  // ? HOOK-FORM
  const {
    setValue,
    formState: { errors },
    control,
    handleSubmit
  } = form;
  
  // ? HOOK-WATCH
  const checkedStatusEmpleado = useWatch({
    control,
    name: "filtro.checkedStatusEmpleado"
  });

  const todos = useWatch({
    control,
    name: "filtro.todos"
  });
  
  const filtro = useWatch({
    control,
    name: "filtro"
  });

  // ? HOOK-EFFECT
  useEffect(() => {
    setValue("filtro.estado", checkedStatusEmpleado ? 0 : 1);
  }, [checkedStatusEmpleado]);

  useEffect(() => {

    setListaAreasState([
      { id: 0, nombre: "Seleccionar Área" },
      ...listAreaOrganizacionales,
    ]);
    setListaEmpleadosState([
      { id: 0, nombreLabel: "Seleccionar Empleado" },
      ...listEmpleados,
    ]);
  }, [listAreaOrganizacionales, listEmpleados]);

  useEffect(() => {
    dispatch(fetchAllEmpleados());
    dispatch(fetchAreasOrganizacionales());
  }, []);

  // * FUNCION QUE ENVIA LOS DATOS.
  const onSubmit = () => {
    setArea(listAreaOrganizacionales.find(x => x.areaId === filtro.areaId)?.nombre);
    
    // * FILTRO
    const filtroApi = {
      empleadoId: filtro.empleadoId,
      areaId: filtro.areaId,
      estado: filtro.estado,
      desde: moment(filtro.desde).format('YYYY-MM-DD'),
      hasta: moment(filtro.hasta).format('YYYY-MM-DD'),
      todos: filtro.todos,
    }

    searchReporteAsistencia(filtroApi);
  };

  // * FUNCION PARA GENERAR EL REPORTE EN EXCEL.
  const onExport = () => {

    // * FILTRO
    const filtroApi = {
      empleadoId: filtro.empleadoId,
      areaId: filtro.areaId,
      estado: filtro.estado,
      desde: moment(filtro.desde).format('YYYY-MM-DD'),
      hasta: moment(filtro.hasta).format('YYYY-MM-DD'),
      todos: filtro.todos,
    }
    
    // * DATA DEL REPORTE
    const dataFiltro = {
      area: filtro.areaId !== 0 ? listAreaOrganizacionales.find(x => x.id === filtro.areaId) : {},
      empleado: filtro.empleadoId !== 0 ? listEmpleados.find(x => x.id === filtro.empleadoId) : {}
    };

    ReporteAsistenciaExcel({filtro: filtroApi, dataFiltro})
  };

  // * FUNCION PARA ENVIAR CORREOS A TODOS LOS SUPERVISORES.
  const sendEmailsArea = () => {

    swal({
		  title: "¿Está seguro de que desea enviar los reportes de asistencia a los directores o viceministros correspondientes de cada área?",
		  icon: "warning",
		  buttons: true,
		  dangerMode: true,
		}).then((answer) => {
		  if (answer) {
        dispatch(fetchEnvioCorreoSupervisores({
          fechaInicio: filtro.fechaDesde,
          fechaFin: filtro.fechaHasta
        }))
		  } 
    });

  }

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="card mb-4">
        <div className="card-body">
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <label className="fw-bold">Fecha Desde</label>
                <Controller
                  control={control}
                  className="mb-3"
                  name="filtro.desde"
                  render={({ field: { value, onChange} }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat='dd/MM/yyyy'
                        label={" "}
                        mask="__/__/____"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField
                            height={10}
                            className="form-control"
                            style={{ height: 10 }}
                            {...params}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                />
                <p className="text-danger mt-3">
                  {errors.fechaInicio?.message}
                </p>
                <p className="text-danger">{errors.nombres?.message}</p>
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <label className="fw-bold">Fecha Hasta</label>
                <Controller
                  control={control}
                  className="mb-3"
                  name="filtro.hasta"
                  render={({ field: { value, onChange } }) => (
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        inputFormat='dd/MM/yyyy'
                        minDate={filtro.desde}
                        label={" "}
                        mask="__/__/____"
                        value={value}
                        onChange={onChange}
                        renderInput={(params) => (
                          <TextField
                            height={10}
                            className="form-control"
                            style={{ height: 10 }}
                            {...params}
                          />
                        )}
                      />
                    </LocalizationProvider>
                  )}
                />
                <p className="text-danger mt-3">
                  {errors.fechaTermino?.message}
                </p>
                <p className="text-danger">{errors.nombres?.message}</p>
              </div>
            </div>
            <div className="form-group mt-2">
              <label className="fw-bold">Área</label>

              <Controller
                control={control}
                name="filtro.areaId"
                render={({ field: { value, onChange} }) => (
                <Select
                  id='select-area'
                  classNamePrefix="select"
                  className="mb-3"
                  isSearchable={true}
                  placeholder="Seleccionar Área"
                  options={listaAreasState}
                  getOptionLabel={(option) => option.nombre}
                  getOptionValue={(option) => option.id}
                  onChange={(e) => onChange(e.id)}
                  value={listaAreasState.find(x => x.id === value)}
                />
                )}
              />

            </div>
            <div className="form-group">

              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="checkbox-empleados"
                      checked={todos}
                      onChange={() => setValue('filtro.todos', !todos)}
                    />
                  }
                  label="Todos los empleados pertenecientes a esta área "
                />
              </FormGroup>

              {/* <p className='text-danger mt-3'>{errors.fecha?.message}</p> */}
            </div>
            <div className="form-group">
              <label className="fw-bold">Empleado</label>

              <Controller
              control={control}
              name="filtro.empleadoId"
              render={({ field: { value, onChange } }) => (
                <Select
                id='select-empleado'
                classNamePrefix="select"
                className="mb-3"
                isSearchable={true}
                placeholder="Seleccionar Empleado"
                options={listaEmpleadosState}
                getOptionLabel={(option) => option.nombreLabel}
                getOptionValue={(option) => option.id}
                onChange={(e) => onChange(e.id)}
                value={listaEmpleadosState.find(x => x.id === value)}
                />
              )}
              />

            </div>
            <div className="form-group">

              <FormGroup>
                <FormControlLabel
                  control={
                    <Checkbox
                      id="checkbox-empleados-inactivos"
                      checked={checkedStatusEmpleado}
                      onChange={() => setValue('filtro.checkedStatusEmpleado', !checkedStatusEmpleado)
                      }
                    />
                  }
                  label="Incluir empleados inactivos pertenecientes a esta área "
                />
              </FormGroup>

              {/* <p className='text-danger mt-3'>{errors.fecha?.message}</p> */}
            </div>
            <div className="text-end">
              <button
                id="btn-buscar"
                type="submit"
                className={
                  filtro.areaId > 0 || filtro.empleadoId > 0
                    ? "btn btn-primary-mem rounded me-2"
                    : "btn btn-primary-mem rounded me-2 disabled"
                }
                title="Buscar"
              >
                <Search/>
              </button>
              <button
                id="btn-descargar"
                type="button"
                onClick={() => onExport()}
                className={ filtro.areaId > 0 || filtro.empleadoId > 0 ? 'btn btn-success rounded-6 me-2' : 'btn btn-success rounded-6 me-2 disabled'}
                title="Descargar"
              >
                <CloudDownload />
              </button>
              
              <button 
              type="button"
              onClick={() => sendEmailsArea()}
              title="Enviar correos a Supervisores"
              className={"btn btn-warning rounded me-2"}
              >
                <TfiEmail fontSize={23} />
              </button>

                <a type="dow">

                </a>

              <button title="Limpiar" type="button" onClick={() => reset()} id="btn-eliminar" className="btn btn-danger">
                <Delete />
              </button>

            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default FiltroReporteAsistenciaCard;
